import { createFileRoute } from '@tanstack/react-router'

import { RulesHealthPage } from '@/components/MarketingRules/RulesHealthPage'

export const Route = createFileRoute('/_app/marketing/rules-v2/health/')({
  component: HealthRoute,
})

function HealthRoute() {
  return <RulesHealthPage />
}
